import { Box, Container, Typography, Card, CardContent } from '@mui/material'
import MailIcon from '@mui/icons-material/Mail'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import LocationOnIcon from '@mui/icons-material/LocationOn'

export default function CTA() {
  const contacts = [
    {
      icon: <MailIcon sx={{ fontSize: '3rem' }} />,
      title: 'Email',
      desc: 'Envie suas dúvidas',
      value: 'bapadua@outlook.com',
      color: '#3b82f6',
    },
    {
      icon: <WhatsAppIcon sx={{ fontSize: '3rem' }} />,
      title: 'WhatsApp',
      desc: 'Chat instantâneo',
      value: '+55(11)98665-9898',
      color: '#22c55e',
    },
    {
      icon: <LocationOnIcon sx={{ fontSize: '3rem' }} />,
      title: 'Localização',
      desc: 'São Paulo, SP',
      value: 'Disponível globalmente',
      color: '#dc2626',
    },
  ]

  return (
    <Box
      component="section"
      id="cta"
      sx={{
        py: { xs: 10, md: 20 },
        px: { xs: 2, sm: 3, lg: 4 },
        position: 'relative',
        overflow: 'hidden',
        background: '#ffffff',
      }}
    >
      {/* Background Elements */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          zIndex: 0,
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '400px',
            height: '400px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(220, 38, 38, 0.1) 0%, transparent 70%)',
            filter: 'blur(80px)',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: '400px',
            height: '400px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(249, 115, 22, 0.1) 0%, transparent 70%)',
            filter: 'blur(80px)',
          },
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        {/* Contact Info Grid - Centered */}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 4, mb: 10, maxWidth: '1000px', mx: 'auto' }}>
          {contacts.map((contact) => (
            <Card
              key={contact.title}
              elevation={0}
              sx={{
                h: '100%',
                border: '1px solid #e5e7eb',
                borderRadius: '1.5rem',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: `0 20px 40px ${contact.color}30`,
                  borderColor: contact.color,
                },
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Box sx={{ color: contact.color, mb: 2 }}>
                  {contact.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: '#1f2937',
                    mb: 0.5,
                  }}
                >
                  {contact.title}
                </Typography>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontSize: '0.9rem',
                    mb: 1.5,
                  }}
                >
                  {contact.desc}
                </Typography>
                <Typography
                  component="a"
                  href={contact.title === 'Email' ? `mailto:${contact.value}` : contact.title === 'WhatsApp' ? 'https://wa.me/5511986659898' : '#'}
                  target={contact.title === 'WhatsApp' ? '_blank' : undefined}
                  rel={contact.title === 'WhatsApp' ? 'noopener noreferrer' : undefined}
                  sx={{
                    color: contact.color,
                    fontWeight: 700,
                    fontSize: '1rem',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    '&:hover': {
                      opacity: 0.8,
                    },
                  }}
                >
                  {contact.value}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>

      </Container>
    </Box>
  )
}
